import { sendMessageCommand } from "@/lib/public-api/commands/send-message";
import type { PublicApiCommand, PublicApiCommandName } from "@/lib/public-api/types";

const commands: Record<PublicApiCommandName, PublicApiCommand> = {
  sendMessage: sendMessageCommand,
};

export function listPublicApiCommands(): PublicApiCommand[] {
  return Object.values(commands);
}

export function getPublicApiCommand(name: string): PublicApiCommand | undefined {
  return commands[name as PublicApiCommandName];
}
